
	/**
	 * @description
	 *  Modelo de un material.
	 *
	 * @see gigot-backend/Models/Products/Material.cs
	 */

export class Material {

	;

	/**
	 * @description
	 *	Construye un material con una semántica vacía. Nótese que no es lo
	 *  mismo que construir un material con valores por defecto. Las reglas
	 *  generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Un material vacío.
	 */
	public static empty(): Material {
		const material: Material = new Material();
		return material;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicMaterial
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicMaterial: Material): Material {
		if (!anemicMaterial) return undefined;
		const material: Material = Material.empty();
		return material;
	}
}
